import { ReactNode } from 'react';

import { TooltipProps } from '@mui/material';

import { HoverCard } from '@/shared/ui/HoverCard';

export type FeatureTooltipItem = {
  title?: string;
  description?: string;
  image?: string;
  link?: string;
  linkTitle?: string;
  placement?: TooltipProps['placement'];
  sendMixpanelEvent?: () => void;
};

export type FeatureTooltipProps = {
  children: ReactNode;
  tooltipProps?: FeatureTooltipItem;
  onSendMixpanelEvent?: () => void;
};

// @deprecated use it only for old pricing
export const FeatureTooltip = ({ children, tooltipProps, onSendMixpanelEvent }: FeatureTooltipProps) => {
  if (!tooltipProps) {
    return children;
  }

  const { title, description, image, link, linkTitle, placement } = tooltipProps;

  return (
    <HoverCard
      content={
        <>
          {image && <HoverCard.Image alt={title} src={image} />}
          <HoverCard.Content>
            <HoverCard.Title>{title}</HoverCard.Title>
            {description && <HoverCard.Description>{description}</HoverCard.Description>}
            {link && <HoverCard.Link src={link}>{linkTitle || 'Learn more'}</HoverCard.Link>}
          </HoverCard.Content>
        </>
      }
      cursor="help"
      placement={placement}
      onTooltipOpen={onSendMixpanelEvent}
    >
      {children}
    </HoverCard>
  );
};
